/** @format */
import ua from "./ua";
import en from "./en";
import fr from "./fr";
export const languages = {
  en,
  ua,
  fr,
};
